import { cn } from '@/lib/utils';
import {
  CARRY_DOCUMENT_STATUS_LABELS,
  type CarryDocumentStatus,
} from '@/types/carryDocument';
import { STATUS_PILL_CLASSES } from './carryDocumentStatus';

export function CarryDocumentStatusBadge({
  status,
}: {
  status: CarryDocumentStatus;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold whitespace-nowrap',
        STATUS_PILL_CLASSES[status]
      )}
    >
      {CARRY_DOCUMENT_STATUS_LABELS[status]}
    </span>
  );
}
